export function getUFDigitFromCPF(cpf) {
  const cleanedCpf = cpf.replace(/[^\d]/g, '');
  if (cleanedCpf.length !== 11) return '';

  return parseInt(cleanedCpf.charAt(8), 10);
}
